<!-- FBA列表 -->
<template>
	<div 
	:lang="$i18n.locale"
	v-loading.fullscreen="uploadloading"
	:element-loading-text="$t('tipsInfo.uploading')"
	element-loading-spinner="el-icon-loading"
	element-loading-background="rgba(0, 0, 0, 0.8)" 
	class>
		<div class="listHeader">
			<i></i><span>{{$t('commonInfo.orderList')}}</span>
		</div>
		<el-form :model="queryParams" ref="queryForm" :inline="true" label-width="auto" style="margin:10px 0 0 20px">
			<el-form-item label>
				<el-input v-model="companyProductCode" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.clientOrderNoColumn')" type="textarea" clearable />
			</el-form-item>
			<el-form-item label>
				<el-input v-model="FbaNo" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.fbaNo')" type="textarea" clearable />
			</el-form-item>
			<el-form-item label>
				<el-date-picker v-model="searchOPTime" type="datetimerange" range-separator="-"
					:start-placeholder="$t('commonInfo.beginTime')" :end-placeholder="$t('commonInfo.endTime')"
					value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"
					style="width:350px"></el-date-picker>
			</el-form-item>
			<el-form-item label>
				<!-- 订单类型 -->
				<el-select v-model="queryParams.itemType" placeholder="请选择类型">
					<el-option v-for="item in itemTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label>
				<el-input v-model="queryParams.exp" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.remark')" type="text" clearable />
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="handleQuery">{{$t('commonInfo.searchBtn')}}</el-button>
				<el-button icon="el-icon-refresh" @click="handleRefresh">{{$t('commonInfo.refreshBtn')}}</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="handleAdd()">{{$t('commonInfo.createBtn')}}</el-button>
				<el-button type="success" icon="el-icon-download" @click="handleExport">{{$t('commonInfo.exportExcel')}}</el-button>
			</el-form-item>
		</el-form>

		<!-- 展示 -->
		<el-table style="margin:0 15px;width: calc(100% - 30px)" v-loading="loading" :data="dataList" border>
			<el-table-column :label="$t('commonInfo.clientOrderNoColumn')" align="center" prop="customerOrderNo" width="140" />
			<el-table-column label="原头程订单号" align="center" width="160">
				<template slot-scope="{ row }">
					<template v-if="row.itemType === 'CARTON' && row.orderNoList && row.orderNoList.length">
						<el-popover v-if="row.orderNoList.length > 5" placement="bottom" trigger="click" width="180">
							<div v-for="orderNo in row.orderNoList" :key="orderNo">{{ orderNo }}</div>
							<el-button slot="reference" type="text">{{ row.orderNoList[0] }}... 查看全部</el-button>
						</el-popover>
						<template v-else>
							<div v-for="orderNo in row.orderNoList" :key="orderNo">{{ orderNo }}</div>
						</template>
					</template>
				</template>
			</el-table-column>
			<el-table-column :label="'类型'" align="center" prop="itemType" width="100px" />
			<el-table-column :label="$t('commonInfo.fbaNo') + '/' + $t('commonInfo.asnNo')" align="center" prop="fbaNo" width="130" />
			<el-table-column :label="$t('commonInfo.deliveryDate')" align="center" prop="deliveryDate" width="140">
			  <template slot-scope="{ row }">
					<span v-if="row.deliveryDate == null && row.orderType == 'FBA'">{{$t('commonInfo.fleetanAppointment')}}</span>
					<!-- OWH订单，显示日期 其他显示时间-->
					<span v-else-if="row.orderType == 'OWH'">{{row.deliveryDate.split(' ')[0]}}</span>
					<span v-else>{{row.deliveryDate}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.productCount')" align="center">
				<template slot-scope="{ row }">
					<span>{{row.productList == null?0:row.productList.length}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.pcsCount')" align="center">
				<template slot-scope="{ row }">
					<span>{{countPCS(row)}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.actualCarton')" align="center" prop="actualPackingCount"></el-table-column>
			<el-table-column :label="$t('commonInfo.deliveryWarehouse')" align="center" prop="receiverAddress" width="140">
				<template slot-scope="{row}">
					<div v-if="row.receiverAddress == 'custom'">
						<span v-if="row.receiverDetailAddress.length < 14">{{row.receiverDetailAddress}}</span>
						<div v-else>
							<p style="margin: 0;">{{row.receiverDetailAddress.substring(0,14) + '...'}}</p>
							<el-button size="mini" type="text"
								@click="handleCheckExpDetail(row.receiverDetailAddress)">{{$t('commonInfo.actionDetail')}}</el-button>
						</div>
					</div>
					<span v-else>{{ row.receiverAddress }}</span>
					<br v-if="row.deliveryType == '2'"/>
					<span style="color: #0058b3" v-if="row.deliveryType == '2'">{{'(' + $t('commonInfo.selfPickup') +')'}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.orderType')" align="center" prop="orderType" width="115px">
				<template slot-scope="{row}">
					<span>{{row.orderType}}</span><br>
					<span style="color: burlywood;" v-if="row.orderType == 'DS'&&  row.cancelProductCount != 0 ">{{$t('commonInfo.cancelProductCount')}}:{{row.cancelProductCount}}</span>
					<span style="color: burlywood;" v-if="row.orderType == 'DS'&& row.cancelProductCount == 0 && returnNum(row)>0 ">{{$t('commonInfo.cancelProductCount')}}:{{ returnNum(row) }}</span>
				</template>
			</el-table-column>
			<el-table-column :label="'NOON ' + $t('commonInfo.companyId')" align="center" prop="sendCompany" width="150" />
			<el-table-column :label="$t('commonInfo.statusColumn')" align="center" prop="orderStatus" width="100" >
				<template slot-scope="scope">
					<div>
						<span style="display: block;">{{returnStatusName(scope.row)}}</span>
						<div v-if="isShowPod(scope.row)">
							<el-button type="text" icon="el-icon-picture" style="height: 22px; padding: 0px;"
								size="small" @click="checkPOD(scope.row.podLink)">{{$t('commonInfo.actionCheckPOD')}}</el-button>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="DJ状态" align="center" width="130">
				<template slot-scope="{ row }">
					<el-tag v-if="row.djCreationStatus === 'CREATED'" size="mini" type="success">已创建</el-tag>
					<el-button v-else-if="row.djCreationStatus === 'RELEASE_BLOCKED'" type="text"
						size="mini" class="release-block-link" @click="openReleaseFailures(row)">待放货重试</el-button>
					<el-tag v-else-if="row.itemType === 'CARTON'" size="mini" type="info">创建中</el-tag>
					<span v-else>--</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.remark')" align="center" prop="exp" width="140">
				<template slot-scope="{row}">
					<span v-if="row.exp == '' || row.exp == null || row.exp.length<60">{{row.exp}}</span>
				  <div v-else>
				    <p>{{row.exp.substring(0,16) + '...'}}</p>
				    <el-button size="mini" type="text"
				    	@click="handleCheckExpDetail(row.exp)">{{$t('commonInfo.actionDetail')}}</el-button>
				  </div>
				</template>
			</el-table-column>
			<el-table-column label="换标要求" align="center" width="145">
				<template slot-scope="{row}">
					<div v-if="row.itemType === 'CARTON'">
						<div v-if="row.orderType === 'FBA'">更新箱唛：{{ row.isNeedNewLabel === '1' ? '是' : '否' }}</div>
						<div>SKU换标：{{ row.isNeedSkuNewLabel === '1' ? '是' : '否' }}</div>
					</div>
					<span v-else>--</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.createTimeColumn')" align="center" prop="initTime" width="160" />
			<el-table-column :label="$t('commonInfo.operationColumn')" align="center" class-name="small-padding fixed-width" fixed="right"
				width="160px">
				<template slot-scope="{ row }">
					<el-button size="mini" type="text" icon="el-icon-s-promotion" @click="handleTrack(row.customerOrderNo)">{{$t('commonInfo.actiontrack')}}</el-button>
					<el-dropdown style="margin-left: 10px;" @command="handleCommand">
						<span style="font-size: 12px; color: #409EFF;" class="el-dropdown-link">{{$t('commonInfo.moreAction')}}<i class="el-icon-arrow-down el-icon--right"></i></span>
						<el-dropdown-menu slot="dropdown">
							<!-- 修改订单 -->
							<el-dropdown-item v-if="row.statusCode == 'n100'" icon="el-icon-edit" :command="{'command':'e','row':row}">{{ $t('commonInfo.modifyOrder') }}</el-dropdown-item>
							<!-- <el-dropdown-item v-if="returnIsEditTime(row)" icon="el-icon-edit" :command="{'command':'a','row':row}">{{ $t('commonInfo.actionModifyDeliveryTime') }}</el-dropdown-item> -->
							<el-dropdown-item v-if="row.productList && row.productList.length > 0" icon="el-icon-view" :command="{'command':'b','row':row}">{{row.itemType == 'SKU'?$t('commonInfo.actionCheckProduct'):'SKU换标详情'}}</el-dropdown-item>
							<el-dropdown-item v-if="row.itemType == 'CARTON'" icon="el-icon-view" :command="{'command':'c','row':row}">箱信息</el-dropdown-item>
							<el-dropdown-item v-if="row.newLabelLinkList != null && row.newLabelLinkList.length > 0" icon="el-icon-download" :command="{'command':'d','row':row}">{{ $t('commonInfo.newLabelFile') }}</el-dropdown-item>
							<el-dropdown-item v-if="row.orderType == 'FBA'" icon="el-icon-download" :command="{'command':'g','row':row}">{{ $t('commonInfo.downloadBoxStickers') }}</el-dropdown-item>
							<!-- 备货完成前可以取消订单 -->
							<el-dropdown-item v-if="returnOrderStatus(row)" icon="el-icon-close" :command="{'command':'f','row':row}">{{ $t('B2BStatus.cancelOrder') }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
		</el-table>

		<div class="pageBottom">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryParams.page" :page-sizes="[10, 20, 30, 40]" :page-size="queryParams.limit"
				layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
		</div>
		<el-image-viewer v-if="showImg" :on-close="closeImg" :url-list="imgList" />
        <!-- 查看商品 -->
        <CheckProduct 
          :visible.sync="productPopup"
	      :rowData="rowData" 
		/>
        <!-- 查看轨迹 -->
        <CheckTracking 
          :visible.sync="trackingPopup"
	      :orderNo="currentOrderNo" 
		/>
        <!-- 下载换标文件 -->
        <DownloadNewLabel 
          :visible.sync="newLabelPopup"
	      :labelLinks="newLabelTableData" 
		/>
        <!-- 更新预约派送时间 -->
        <UpdateApTiem 
          :visible.sync="timePopup"
	      :orderData="currentOrderData" 
	      @refreshList="getList"
		/>
        <!-- 选择创建订单类型 -->
        <ChooseCreateType 
          :visible.sync="createTypePopup"
	      :showCarton="showCarton" 
	      @chooseType="ChooseCreateType"
		/>
        <!-- 创建SKU类型订单 -->
        <CreateSkuOrder 
          :visible.sync="skuOrderPopup"
	      @refreshList="getList"
		/>
        <!-- 创建整箱类型订单 -->
        <CreateCartonOrder 
          :visible.sync="cartonOrderPopup"
      @refreshList="getList"
		/>
        <!-- 查看箱信息 -->
        <CheckCarton 
          :visible.sync="cartonPopup"
          :orderId="currentOrderId"
		/>
		<!-- 更新订单 -->
		<UpdateOrder 
          :visible.sync="updateOrderPopup"
          :rowData="currentOrderData"
		/>
		<el-dialog title="扣放货阻断明细" :visible.sync="releaseFailureDialog" width="620px" append-to-body>
			<el-table :data="releaseFailures" border size="small">
				<el-table-column prop="orderNo" label="原始主订单" min-width="150" />
				<el-table-column prop="customerReason" label="阻断原因" min-width="220" />
				<el-table-column prop="reasonCode" label="原因码" min-width="150" />
			</el-table>
			<span slot="footer">
				<el-button @click="releaseFailureDialog = false">关闭</el-button>
				<el-button type="primary" :loading="retryLoading" @click="retryCartonDelivery">重新尝试创建 DJ</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import CheckProduct from "./checkProduct.vue";
import CheckTracking from "./checkTracking.vue";
import DownloadNewLabel from "./downloadNewLabel.vue";
import UpdateApTiem from "./updateApTiem.vue";
import ChooseCreateType from "./chooseCreateType.vue";
import CreateSkuOrder from "./createSkuOrder.vue";
import CreateCartonOrder from "./createCartonOrder.vue";
import CheckCarton from "./checkCarton.vue";
import UpdateOrder from "./updateOrder.vue";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import {downloadStream} from "@/utils/downloadFileStream";
	export default {
		components: {
			ElImageViewer,
			CheckProduct,
			CheckTracking,
			DownloadNewLabel,
			UpdateApTiem,
			ChooseCreateType,
			CreateSkuOrder,
			CreateCartonOrder,
			CheckCarton,
			UpdateOrder,
		},
		data() {
			return {
				queryParams: {
					page: 1,
					limit: 10,
					customerOrderNos: [],
					fbaNos: [],
					startDate: '',
					endDate: '',
					exp:'',
					itemType: '',
				},
				itemTypeList: [
					{value: 'SKU', label: 'SKU'},
					{value: 'CARTON', label: 'CARTON'},
				],
				companyProductCode: '',
				FbaNo: '',
				loading: false,
				uploadloading:false,
				total: 0,
				searchOPTime: [],
				dataList: [],
				imgList: [],
				showImg: false,
				productPopup: false,
				rowData: {},
				// 查看轨迹
				trackingPopup: false,
				currentOrderNo: '',
				// 下载换标文件
				newLabelPopup: false,
				newLabelTableData: [],
				// 更新预约派送时间
			timePopup: false,
			currentOrderData: {},
			// 选择创建订单类型
			createTypePopup: false,
			showCarton: false,
			// 创建SKU类型订单
			skuOrderPopup: false,
			// 创建整箱类型订单
			cartonOrderPopup: false,
			cartonPopup: false,
			currentOrderId: null,
			releaseFailureDialog: false,
			releaseFailures: [],
			retryFbxOrderNo: '',
			retryLoading: false,

			// 修改订单
			updateOrderPopup: false,
			pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now() + 24 * 60 * 60 * 1000;
					}
				},
			};
		},
		methods: {
			handleSizeChange(size) {
				this.queryParams.limit = size;
				this.queryParams.page = 1;
				this.getList();
			},
			handleCurrentChange(page) {
				this.queryParams.page = page;
				this.getList();
			},
			closeImg() {
				this.showImg = false;
			},
			isShowPod(row) {
				let isShow = false;
				if (row.statusCode == 'n710' || row.statusCode == 'n800') {
					if (row.podLink != null && row.podLink != '') {
						isShow = true;
					}
				}
				return isShow
			},
			checkPOD(url) {
				this.imgList = [];
				if (url.length > 0) {
					var that = this;
					that.showImg = true;
					url.forEach(item => {
						that.imgList.push(item);
					})
				} else {
					this.$message.error(this.$t('tipsInfo.noPodInfo'));
				}
			},
			returnStatusName(row){
				let name = '';
				switch(row.statusCode){
					case '101': name = this.$t('B2BStatus.creating'); break;
					case 'n100': name = this.$t('B2BStatus.init'); break;
					case 'n101': name = this.$t('B2BStatus.warehousing'); break;
					case 'n200': name = this.$t('B2BStatus.cnReceive'); break;
					case 'n240': name = this.$t('B2BStatus.cnPartialShipment'); break;
					case 'n300': name = this.$t('B2BStatus.cnOutscan'); break;
					case '-300': name = this.$t('B2BStatus.cnOutscanExceptionPart'); break;
					case '-302': name = this.$t('B2BStatus.cnTransitExceptionCheck'); break;
					case 'n301': name = this.$t('B2BStatus.cnAir'); break;
					case '-305': name = this.$t('B2BStatus.cnTransitException'); break;
					case '307': name = this.$t('B2BStatus.cnTransitExceptionOr'); break;
					case '-310': name = this.$t('B2BStatus.cnAirExceptionDelay'); break;
					case '-311': name = this.$t('B2BStatus.cnAirExceptionCancel'); break;
					case 'n302': name = this.$t('B2BStatus.airArrived'); break;
					case 'n400': name = this.$t('B2BStatus.customsClearanceCompLated'); break;
					case '-401': name = this.$t('B2BStatus.customsClearanceComplatedExceptionCheck'); break;
					case '-402': name = this.$t('B2BStatus.customsClearanceComplatedExceptionDeduction'); break;
					case 'n510': name = this.$t('B2BStatus.overseasArrived'); break;
					case 'n500': name = this.$t('B2BStatus.ksaInscan'); break;
					case '-520': name = this.$t('B2BStatus.cartonToSku'); break;
					case 'n699': name = this.$t('B2BStatus.ksaReadyForDispatch'); break;
					case 'n700': name = this.$t('B2BStatus.delivering'); break;
					case '-700': name = this.$t('B2BStatus.deliveryFailed'); break;
					case 'n710': name = this.$t('B2BStatus.partialreceipt'); break;
					case 'n800': name = this.$t('B2BStatus.successfulDelivery'); break;
					case '-800': name = this.$t('B2BStatus.signingFailed'); break;
					case '-100': name = this.$t('B2BStatus.cancelOrder'); break;
					case '-600': name = this.$t('B2BStatus.transferThirdpartyDelivery'); break;
					default: name = row.orderStatus; break;
				}
				return name
			},
			countPCS(row) {
                if (row.itemType === 'CARTON' && row.pcsCount != null) {
                    return row.pcsCount;
                }
				if (row.productList.length == 0) {
					return 0;
				} else {
					let pcsNum = 0;
					row.productList.forEach(item => {
						pcsNum += item.productAmount;
					})
					return pcsNum;
				}
			},
			async getList() {
				this.loading = true;
				this.dataList = [];
				if (this.FbaNo != '') {
					this.queryParams.fbaNos = this.strToArr(this.FbaNo);
				}else{
					this.queryParams.fbaNos = [];
				}
                if(this.searchOPTime && this.searchOPTime.length > 0){
                    this.queryParams.startDate = this.searchOPTime[0];
                    this.queryParams.endDate = this.searchOPTime[1];
                }else{
                    this.queryParams.startDate = '';
                    this.queryParams.endDate = '';
                }
				if (this.companyProductCode != '') {
					this.queryParams.customerOrderNos = this.strToArr(this.companyProductCode);
				}else{
					this.queryParams.customerOrderNos = [];
				}
				const res = await this.$http.post("/toborder/wms/fulfillment/query", this.queryParams);
				if (res.code === 200) {
					let data = res.data.list;
					// 总共有多少条数据，分页
					this.total = res.data.totalCount;
					res.data.list.forEach(item => {
					  item.productList = item.productList || [];
					})
					this.dataList = JSON.parse(JSON.stringify(res.data.list));
					
					this.loading = false;
				} else {
					this.loading = false;
					this.$message.error(res.msg);
				}
			},
			handleQuery() {
				this.queryParams.page = 1;
				this.getList();
			},
			handleRefresh() {
				this.queryParams = {
					page: 1,
					limit: 10,
					customerOrderNos: [],
					fbaNos: [],
					startDate: '',
					endDate: '',
					exp:'',
					itemType: '',
				}
				this.getList();
			},
			handleExport() {
				this.queryParams.fbaNos = this.FbaNo === '' ? [] : this.strToArr(this.FbaNo);
				this.queryParams.customerOrderNos = this.companyProductCode === '' ? [] : this.strToArr(this.companyProductCode);
				if (this.searchOPTime && this.searchOPTime.length > 0) {
					this.queryParams.startDate = this.searchOPTime[0];
					this.queryParams.endDate = this.searchOPTime[1];
				} else {
					this.queryParams.startDate = '';
					this.queryParams.endDate = '';
				}
				this.$http.post("/toborder/wms/fulfillment/export", this.queryParams, {
					responseType: 'blob',
					timeout: 120000
				}).then((res) => {
					const date = new Date();
					const today = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
					downloadStream(res, 'xlsx', 'FBX订单列表_' + today + '.xlsx');
					this.$message.success(this.$t('tipsInfo.exportSuccess'));
				}).catch((err) => {
					this.$message.error(err.msg || this.$t('tipsInfo.exportFailed'));
				});
			},
			handleAdd() {
				// 打开选择创建订单类型窗口
				this.createTypePopup = true;
			},
			// 选择创建订单类型
		    ChooseCreateType(type) {
			// 根据选择的类型打开对应的订单创建窗口
			if (type === '1') {
				// 打开创建SKU类型订单窗口
				this.skuOrderPopup = true;
			} else if (type === '2') {
				// 打开创建整箱类型订单窗口
				this.cartonOrderPopup = true;
			}
		    },
			// 列表更多操作
			handleCommand(val) {
				let row = val.row;
				// 判断操作按钮
				switch (val.command) {
					// 修改送仓时间
					case 'a':
						this.handleEditTime(row);
						break;
					// 查看商品
					case 'b':
						this.handleView(row);
						break;
				    // 查看箱信息
					case 'c':
						this.handleViewCarton(row);
						break;
					// 下载换标文件
					case 'd':
						this.handleDownloadNewLabel(row);
						break;
					// 修改订单
					case 'e':
						this.handleModifyOrder(row);
						break;
					// 取消订单
					case 'f':
						this.handleCancelOrder(row);
						break;
					// 下载箱贴
					case 'g':
						this.handleDownloadBoxStickers(row);
						break;
				}
			},
			handleEditTime(row) {
				// 打开更新预约派送时间窗口
				this.timePopup = true;
				this.currentOrderData = row;
			},
			handleView(row) {
				this.productPopup = true;
				this.rowData = row;
			},
			// 查看箱信息
			handleViewCarton(row) {
				this.cartonPopup = true;
				this.currentOrderId = row.id;
			},
			handleDownloadNewLabel(row) {
				// 打开下载换标文件窗口
				this.newLabelPopup = true;
				this.newLabelTableData = row.newLabelLinkList;
			},
			// 下载箱贴
			handleDownloadBoxStickers(row){
				window.open(row.fbaBoxPdfLink)
			},
			handleTrack(id) {
				// 打开轨迹详情窗口
				this.currentOrderNo = id;
				this.trackingPopup = true;
			},
			openReleaseFailures(row) {
				let failures = [];
				try {
					failures = row.djFailureSummary ? JSON.parse(row.djFailureSummary) : [];
				} catch (error) {
					failures = [];
				}
				this.releaseFailures = failures.length > 0 ? failures : [{
					orderNo: '--',
					customerReason: '放货状态暂不可用，请稍后重试',
					reasonCode: 'RC_RELEASE_BLOCKED'
				}];
				this.retryFbxOrderNo = row.customerOrderNo;
				this.releaseFailureDialog = true;
			},
			async retryCartonDelivery() {
				if (!this.retryFbxOrderNo || this.retryLoading) return;
				this.retryLoading = true;
				try {
					const res = await this.$http.post('/toborder/wms/fulfillment/retryCartonDelivery/'
						+ encodeURIComponent(this.retryFbxOrderNo));
					if (res.code === 200) {
						this.$message.success('已重新提交创建 DJ');
						this.releaseFailureDialog = false;
						this.getList();
					} else {
						const reason = res.data && res.data[0] ? res.data[0].errorMsg : res.msg;
						this.$message.error(reason);
					}
				} finally {
					this.retryLoading = false;
				}
			},
			handleCheckExpDetail(val) {
				let exp = val.split(']');
				let message = '';
				exp.forEach(item => {
					message += item + ']</br>';
				})
				message = message.substr(0,message.length - 6)
				let html = "<span style='word-break:break-word'>"+message+"</span>";
				this.$alert(html, 'Info', {
					confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
					dangerouslyUseHTMLString:true,
				});
			},
			returnIsEditTime(row){
				let isTrue = false;
				if(row.orderType == 'FBN'){
					if(row.statusCode == 'n100'){
						isTrue = true;
					}
				}
				return isTrue;
			},
			returnNum(row) {
				let num = 0;
			    row.productList.forEach(item => {
				if(item.boxLabelNew == null){
					return 0;
				}else{
					num +=  parseInt(item.boxLabelNew);
				}
			})
			return num;
			},
			// 修改订单
			handleModifyOrder(row) {
				// 打开修改订单窗口
				this.updateOrderPopup = true;
				this.currentOrderData = row;
			},
			// 返回订单状态编码
			returnOrderStatus(row){
				// 将状态码转换为Int类型且取绝对值
				let code = parseInt(row.statusCode);
				// isNaN 去除非数字字符n
				code = isNaN(code) ? parseInt(row.statusCode.split('n')[1]) : code;
				if(code > 0 && code < 620){
					return true;
				}else{
				    return false;
				}
			},
			// 取消订单
			handleCancelOrder(row) {
				let that = this;
				this.$confirm('确认取消订单吗？', this.$t('commonInfo.dialogBtnConfirm'), {
					confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
					cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
					type: 'warning'
				}).then(() => {
					that.$http.post('/toborder/wms/fulfillment/del/' + row.id).then(res => {
						if (res.code === 200) {
							that.$message.success(that.$t('tipsInfo.operationSuccess'));
							that.getList();
						} else {
							that.$message.error(res.msg);
						}	
					})
				}).catch(() => {
					that.$message({
						type: 'info',
						message: that.$t('已取消操作')
					})
				})
			},
		},
		created() {
			this.getList();
		}
	};
</script>

<style scoped>
	.listHeader {
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-size: 22px;
	}

	.listHeader i {
		width: 4px;
		height: 40px;
		display: inline-block;
		background-color: #0077AA;
		float: left;
		margin: 5px 10px;
	}

	.listHeader span {
		display: inline-block;
		float: left;
	}
	.dialog_orderNo{
		width: 100%;
		height: 50px;
		line-height: 40px;
	}
	.dialog_orderNo label{
		margin-left: 40px;
		font-weight: bold;
		border-radius: 8px;
		font-size: 20px;
		padding: 5px 15px;
		border: 1px solid #EBEEF5;
		box-shadow: 0 2px 4px 0 rgb(0 0 0 / 30%);
	}

	.pageBottom {
		padding: 20px;
	}
	.release-block-link {
		color: #d93025;
		font-weight: 600;
	}
</style>
<style>
.el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {
  display: none;
}
.deliveryTip{
	width: 630px;
	margin-left: 150px;
	margin-bottom: 10px;
	background-color: #fffdd6;
	border-radius: 4px;
	padding: 5px 10px;
}
.deliveryTip h4{
	margin: 0;
	line-height: 30px;
}
.deliveryTip i{
	margin: 0 5px;
}
.deliveryTip span{
	display: block;
	height: 20px;
	line-height: 20px;
	text-indent: 20px;
}
.deliveryTip label{
	display: block;
	height: 20px;
	line-height: 20px;
	text-indent: 40px;
	font-weight: bold;
}
.fileUploadBtn{
	float: left;
	margin: 0 10px;
	max-width: 220px;
}

</style>
<style scoped lang="scss">
	// 阿拉伯语
	[lang="ar"] {
		.listHeader{
			i{
				float: right;
			}
			span{
				float: right;
			}
		}
		
		.el-form-item__content{
			.el-button--primary{
				margin-left: 10px;
			}
		}
		// 表格
		::v-deep .el-table__fixed-right{
			left: 0;
			right: auto;
			.el-table__fixed-body-wrapper{
				left: 0;
				right: auto;
			}
		}
		::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper{
			left: 0;
			right: auto;
		}
		::v-deep .fixed-width .el-button{
			margin: 0 5px 0 0 !important;
			i{
				margin-left: 5px;
			}
		}
		::v-deep .el-dropdown{
			margin: 0 5px 0 0 !important;
			.batchInfoItem{
				width: 20px;
				height: 20px;
				left: -15px;
				right: auto;
				top:-5px;
			}
			span{
				margin-left: -5px;
				float: right;
			}
			i{
				float: right;
				margin: 6px 0 0 5px;
			}
		}
		::v-deep .is-dot {
			left: -2px;
			right: auto;
			top: 6px;
		}
		::v-deep .el-dialog__headerbtn{
			right: auto;
			left: 20px;
		}
		::v-deep .el-select .el-tag{
			margin: 0 5px;
		}
		::v-deep .el-select .el-tag__close.el-icon-close{
			right: 5px;
		}
		::v-deep .el-timeline-item__node--normal{
			right: -15px;
		}
		::v-deep .el-dialog__footer {
			text-align: left;
			.el-button {
				margin: 0 10px;
			}
		}
		.fileUploadBtn{
			float: right;
			margin: 0 10px;
			max-width: 220px;
		}
	}
</style>
